import axios from '../utils/axios';

export default function fetchSubscriptions(adminId, params) {
        return (
            axios.get('/admin/' + adminId + '/manageSeekerSubscriptions/v2/admin/transactions', { params })
        )   
}
